export default {
  data: function () {
    return {
      icons: {
        FULLSCREEN: 'fas fa-compress-wide',
        UP: 'fal fa-chevron-up',
        DOWN: 'fal fa-chevron-down',
        IMPORT: 'fal fa-download',
        EXPORT: 'fal fa-upload',
        PUNTENBOEK_TOETS: 'fal fa-abacus',
        BEREKENDE_TOETS: 'fal fa-calculator',
        INSERT: 'fal fa-plus',
        EDIT: 'fal fa-pen',
        BACK: 'fal fa-angle-double-left',
        BEGINNING: 'fal fa-step-backward',
        ENDING: 'fal fa-step-forward',
        STANDAARD_WAARDE: 'fal fa-star',
        SORT: 'fal fa-sort',
        CLOSE: 'fal fa-times',
        CODE: 'fal fa-code',
        SHARE: 'fal fa-user-friends',
        CALCULATE: 'fal fa-calculator',
        PREVIOUS: 'fal fa-arrow-left',
        NEXT: 'fal fa-arrow-right',
        DISABLED: 'fal fa-ban',
        LEERLING: 'fal fa-user-graduate',
        UITGESCHREVEN: 'fas fa-times-circle',
        INTERVENTIES: 'fal fa-exclamation',
        PUNTENBOEKJE: 'fal fa-calculator-alt',
        ADMINISTRATOR: 'fal fa-users-cog',

        PRINTER: 'fal fa-print',
        PHOTO: 'fal fa-camera',
        BEGELEIDING: 'fas fa-circle begeleiding',
        PRIVE: 'fas fa-square prive',
        DETAILS: 'fal fa-eye',
        OVERZICHT: 'fal fa-eye-slash',
        HORIZONTAL_ELLIPSIS: 'fal fa-ellipsis-h',

        LVS: 'fal fa-id-card',
        MAIL: 'fal fa-envelope',
        BETROKKENE: 'fal fa-user',
        SYNC: 'fal fa-sync',

        DEVELOPER: 'fab fa-connectdevelop',
        USERLOCKED: 'fal fa-user-lock main-menu-icon',

        EXCLAMATION: 'fal fa-exclamation-circle fa-WISA-red',
        EXCLAMATION_TRIANGLE: 'fal fa-exclamation-triangle',
        BAN: 'fal fa-ban',
        MINUS_CIRCLE: 'fal fa-minus-circle',
        SAVE: 'fal fa-save',
        PENCIL: 'fal fa-pencil-alt',
        MOVE: 'fal fa-arrows-alt',
        COPY: 'fal fa-copy',
        DELETE: 'fal fa-trash',
        ELLIPSIS: 'fal fa-ellipsis-v',
        ELLIPSIS_ALT: 'far fa-ellipsis-v',
        ARROW_LEFT: 'fal fa-chevron-left',
        DOUBLE_ARROW_LEFT: 'fal fa-chevron-double-left',
        ARROW_RIGHT: 'fal fa-chevron-right',
        DOUBLE_ARROW_RIGHT: "fal fa-chevron-double-right",
        MENU: 'fal fa-bars',
        CONFIG: 'fal fa-cog',
        HOME: 'fal fa-home',
        HOME_ALT: 'fal fa-home fa-2x text-secondary',
        INFO: 'fal fa-info',
        INFO_CIRCLE: 'fal fa-info-circle',
        INFO_CIRCLE_ALT: 'fal fa-info-circle fa-2x text-secondary',
        LOGOUT: 'fal fa-sign-out-alt  ',
        LOGOUT_ALT: 'fal fa-sign-out-alt fa-2x text-secondary',
        LISTVIEW: 'fal fa-list-ul',
        TILEVIEW: 'fal fa-user',
        CALENDAR: 'fal fa-calendar-alt',
        CALENDAR_EDIT: 'fal fa-calendar-edit',
        CALENDAR_CHECKED: 'fal fa-calendar-check',
        CALENDAR_CHECKED_SOLID: 'fas fa-calendar-check',
        CHECK_CIRCLE: 'fal fa-check-circle',
        CIRCLE: 'fal fa-circle',
        REFRESH: 'fal fa-sync-alt',
        EVALUATION: 'fal fa-chart-line',
        COURSE: 'fal fa-folder',
        GROUP: 'fal fa-object-ungroup',
        BERICHT: 'fal fa-envelope',
        DOCUMENT: 'fal fa-file-alt',
        PAYMENT: 'fas fa-euro-sign',//<i class="fas fa-money-check-alt"></i>
        LINK: 'fal fa-external-link-square-alt',
        TODO: 'fal fa-clipboard-list',
        STAR: 'fal fa-star',
        STAR_FILLED: 'fas fa-star',
        PLAY: 'fal fa-play',
        CARET_UP: 'fal fa-caret-up',
        CARET_DOWN: 'fal fa-caret-down',
        PLAY_DOWN: 'fal fa-play fa-rotate-90',
        SQUARE: 'fal fa-square',
        CHECKED_SQUARE: 'fal fa-check-square',
        UNCHECKED_SQUARE: 'fal fa-square',
        AT: 'fal fa-at',
        PLUS: 'fal fa-plus',
        PLUS_CIRCLE: 'fas fa-plus-circle',
        PLUS_COMMENT: 'fas fa-comment-alt-plus',
        MINUS: 'fal fa-minus',
        EXCHANGE: 'fal fa-exchange-alt',
        MAIN_SPINNER: 'fal fa-spinner fa-spin fa-3x',
        CHECK: 'fal fa-check',
        CALENDAR_DOUBLE_CHECKED: 'fal fa-check-double',
        RESERVATION: 'fas fa-concierge-bell',
        BESCHIKBAARHEIDSKALENDER: 'fab fa-buromobelexperte',
        WEEK_VIEW: 'far fa-th',
        LIJST_VIEW: 'fas fa-th-list',
        DAG_VIEW: 'far fa-th-list',
        DRIE_DAGEN_VIEW: 'fas fa-ellipsis-h-alt',
        ITEM: 'fas fa-info-circle',
        CALENDAR_PLUS: 'fas fa-calendar-plus',
        CALENDAR_MINUS: 'fas fa-calendar-minus',
        RADIO_CHECKED: 'far fa-check-circle',
        RADIO_UNCHECKED: 'far fa-circle',
        CHECK_ONLY: 'fas fa-check',
        FILTER: 'fal fa-filter',
        CATEGORY: 'fal fa-sitemap',
        BALANCE: 'fal fa-balance-scale-right',
        STANDARD: 'fal fa-globe-stand',
        KEY: 'fas fa-key',
        MANAGE: 'fal fa-cogs',
        WEEKEND: 'fas fa-list-alt',
        PROFILE: 'fas fa-user-circle',
        CLOCK: 'fal fa-clock',

        UNCOLLAPSED: 'fas fa-chevron-circle-right',
        COLLAPSED: 'fas fa-chevron-circle-down',

        ONDERWERP: '',
        TAAK: 'fa fa-bookmark fa-taak-color',
        TOETS: 'fa fa-bookmark fa-toets-color',
        AANDACHTSPUNT: 'fa fa-asterisk fa-aandachtspunt-color',
        WAARSCHUWING: 'fa fa-exclamation-circle fa-waarschuwing-color'
      }
    }
  }
}
